module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "custom-classes-transition",
      "enter-active-class": "animated slideInDown",
      "leave-active-class": "animated slideOutUp"
    }
  }, [_c('div', {
    staticClass: "resources"
  }, _vm._l((_vm.items.header), function(item) {
    return _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.resources),
        expression: "item.resources"
      }],
      attrs: {
        "href": item.source,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.resources))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a8d0336"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources.vue
// module id = 147
// module chunks = 0